var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-contaier"},[_c(_vm.component,{tag:"component",attrs:{"componentprops":_vm.componentprops},on:{"disagree":_vm.disagree,"agree":_vm.agree}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }